import shadows from "assets/stylesheets/modules/variables/shadow.module.scss";

export default {
  ...shadows,
  outline: "0 0 0 3px var(--chakra-ui-color-muted)",
  ["rt-lg"]: "0px 0px 35px 0px rgba(0, 0, 0, 0.07)",
  ["rt-md"]: "0px 0px 15px 0px rgba(0, 0, 0, 0.07)",
  ["rt-sm"]: "0px 0px 10 0px rgba(0, 0, 0, 0.1)",
  ["rt-drop-sm"]: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
};
